import React, { useEffect, useState } from 'react'
import api from '../api'
import { Plus, Trash2, Eye, EyeOff, Server } from 'lucide-react'
import { Card, PageHeader, Button, Input, Field, Alert, Select, Badge, EmptyState } from '../components/ui'

// Tipe provider yg didukung frontend -- HARUS sinkron dgn TIPE_DIDUKUNG di server/routes/aiPlatforms.js.
// OpenRouter dulu satu-satunya (2026-07-28), lihat memori admin_app_ai_platforms.
const TIPE_OPSI = [{ value: 'openrouter', label: 'OpenRouter' }]

function kosong() { return { nama: '', tipe: 'openrouter', apiKey: '' } }

export default function AiPlatforms() {
  const [platforms, setPlatforms] = useState([])
  const [baru, setBaru] = useState(kosong())
  const [visibleKeys, setVisibleKeys] = useState({})
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => { load() }, [])

  async function load() {
    const res = await api.get('/ai-platforms')
    setPlatforms(res.data)
  }

  async function tambah() {
    if (!baru.nama.trim()) { setError('Nama platform wajib diisi'); return }
    if (!baru.apiKey.trim()) { setError('API key wajib diisi'); return }
    setError(''); setSaving(true)
    try {
      await api.post('/ai-platforms', baru)
      setBaru(kosong())
      await load()
    } catch (e) {
      setError(e.response?.data?.message || 'Gagal menambah platform')
    } finally {
      setSaving(false)
    }
  }

  async function toggleAktif(p) {
    await api.put(`/ai-platforms/${p.id}`, { aktif: !p.aktif })
    load()
  }

  async function hapus(p) {
    if (!window.confirm(`Hapus platform "${p.nama}"? Fitur yang masih memakai key ini akan berhenti bekerja.`)) return
    await api.delete(`/ai-platforms/${p.id}`)
    load()
  }

  function toggleShow(id) {
    setVisibleKeys(v => ({ ...v, [id]: !v[id] }))
  }

  function maskKey(key) {
    if (!key) return ''
    if (key.length <= 8) return '••••••••'
    return key.slice(0, 4) + '••••••••' + key.slice(-4)
  }

  return (
    <div>
      <PageHeader
        title="Platform AI"
        subtitle="Daftar provider AI beserta API key masing-masing — dipakai bergantian oleh fitur-fitur AI di aplikasi ini (mulai dari AI Asisten internal, menyusul chatbot WA di tahap berikutnya)."
      />

      {error && <Alert type="error">{error}</Alert>}

      <Card style={{ padding: 20, marginBottom: 20 }}>
        <div style={{ fontWeight: 700, fontSize: 14.5, marginBottom: 14 }}>Daftar Platform</div>

        {platforms.length === 0 && (
          <EmptyState icon={Server} title="Belum ada platform AI" hint="Tambahkan platform pertama lewat form di bawah." />
        )}

        {platforms.map(p => (
          <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: '1px solid var(--border)' }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input type="checkbox" checked={p.aktif} onChange={() => toggleAktif(p)} />
            </label>
            <div style={{ flex: '0 0 160px' }}>
              <div style={{ fontWeight: 600, fontSize: 13.5 }}>{p.nama}</div>
              <Badge tone={p.aktif ? 'success' : 'neutral'} style={{ marginTop: 3 }}>
                {TIPE_OPSI.find(t => t.value === p.tipe)?.label || p.tipe}
              </Badge>
            </div>
            <div style={{ flex: 1, fontFamily: 'monospace', fontSize: 12, color: 'var(--text-muted)', wordBreak: 'break-all' }}>
              {visibleKeys[p.id] ? p.apiKey : maskKey(p.apiKey)}
            </div>
            <button
              type="button"
              onClick={() => toggleShow(p.id)}
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', display: 'flex', padding: 4 }}
              aria-label={visibleKeys[p.id] ? 'Sembunyikan API Key' : 'Tampilkan API Key'}
            >
              {visibleKeys[p.id] ? <EyeOff size={15} /> : <Eye size={15} />}
            </button>
            <Button size="sm" variant="danger-soft" icon={Trash2} onClick={() => hapus(p)}>Hapus</Button>
          </div>
        ))}

        <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end', marginTop: platforms.length ? 16 : 0 }}>
          <Field label="Tipe Platform" style={{ flex: '0 0 160px' }}>
            <Select value={baru.tipe} onChange={e => setBaru({ ...baru, tipe: e.target.value })}>
              {TIPE_OPSI.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
            </Select>
          </Field>
          <Field label="Nama" style={{ flex: '0 0 160px' }}>
            <Input value={baru.nama} onChange={e => setBaru({ ...baru, nama: e.target.value })} placeholder="mis. OpenRouter" />
          </Field>
          <Field label="API Key" style={{ flex: 1 }}>
            <Input value={baru.apiKey} onChange={e => setBaru({ ...baru, apiKey: e.target.value })} placeholder="sk-or-v1-..." style={{ fontFamily: 'monospace', fontSize: 12.5 }} />
          </Field>
          <Button icon={Plus} onClick={tambah} loading={saving} style={{ flex: '0 0 auto' }}>Tambah</Button>
        </div>
      </Card>
    </div>
  )
}
